
    import './styles.scoped.css';
    export default {
  "root": "awsui_root_1mabk_kn25a_97",
  "radio": "awsui_radio_1mabk_kn25a_133",
  "radio--has-description": "awsui_radio--has-description_1mabk_kn25a_141",
  "radio-control": "awsui_radio-control_1mabk_kn25a_145",
  "outline": "awsui_outline_1mabk_kn25a_153",
  "styled-circle-border": "awsui_styled-circle-border_1mabk_kn25a_175",
  "styled-circle-disabled": "awsui_styled-circle-disabled_1mabk_kn25a_179",
  "styled-circle-fill": "awsui_styled-circle-fill_1mabk_kn25a_184",
  "styled-circle-checked": "awsui_styled-circle-checked_1mabk_kn25a_190"
};
  